import { getDataAPI, postDataAPI } from "../../../services/apiWrapper";

/*
  NOC, center side.

  A center applies for a NOC on behalf of one of its own students. The shape is
  identical to the student's own flow - apply returns the server's full
  { status, data, message } so the screen can branch on rejected / free / paid,
  and the Razorpay step is the shared utils/nocPay.
*/

const token = () => localStorage.getItem("centerToken");

export const getNocTypes = () => async (dispatch) => {
  try {
    const response = await dispatch(getDataAPI("center/noc/types", token()));
    return response.data.data || [];
  } catch (error) {
    return [];
  }
};

// Whether a given student may apply for a NOC yet (course NOC-required + the
// 6-months-after-completion rule). Used to gate the center's apply modal.
export const getNocEligibility = (studentId) => async (dispatch) => {
  try {
    const response = await dispatch(
      getDataAPI(`center/noc/eligibility/${studentId}`, token())
    );
    return response.data.data || null;
  } catch (error) {
    return null;
  }
};

export const getCenterNoc = () => async (dispatch) => {
  try {
    const response = await dispatch(getDataAPI("center/noc/list", token()));
    return response.data.data || [];
  } catch (error) {
    return [];
  }
};

export const applyNoc = (body) => async (dispatch) => {
  try {
    const response = await dispatch(postDataAPI("center/noc/apply", body, token()));
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failed",
        message: "The request could not be sent. Please try again.",
      }
    );
  }
};

export const payNocSuccess = (body) => async (dispatch) => {
  try {
    const response = await dispatch(
      postDataAPI("center/noc/pay-success", body, token())
    );
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failed",
        message: "Payment could not be verified.",
      }
    );
  }
};
